import ScrollMagic from 'scrollmagic';

$(() => {

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__faq-faq',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__faq-faq .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);

    $('.b-faq-questions__item-title, .b-faq-questions__item-toggle').on('click', function() {

        const text = $(this).parent().find('.b-faq-questions__item-text');
        if ($(this).parent().hasClass('active')){
            text.slideUp('300');
            $(this).parent().removeClass('active');
        }else {
            text.slideDown('300');
            $(this).parent().addClass('active');

        }


    });

});



// WEBPACK FOOTER //
// ./app/scripts/pages/faq.js